import { Tag } from '../../Tags/types';
import { ListProperty } from '../../../components/CustomProperties/ListProperties/types';

export interface PropertySet {
  id?: number;
  replacementKey: string;
  name: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
  additionalConfiguration: AdditionalConfiguration;
  setProperties: SetProperties;
  layout?: any[]; // Legacy field, kept for backward compatibility but no longer used
  tags: Tag[];
}

type AdditionalConfiguration = {
  isCustomProperty?: boolean,
  dynamicDisplaySettings?: {
    properties: {
      [key: string]: {
        replacementKey: string;
        value: string;
        condition: 'is'| 'is not';
      },
    },
    sets: {
      [key: string]: {
        replacementKey: string;
        condition: 'is'| 'is not';
        value: string;
      }
    }
  },
}

type SetProperties = {
  properties: number[];
  propertySets: number[];
  listProperties?: ListProperty[];
};

export const propertySetDefaults: PropertySet = {
  replacementKey: '',
  name: '',
  description: '',
  createdAt: new Date(),
  updatedAt: new Date(),
  additionalConfiguration: {},
  setProperties: {
    properties: [],
    propertySets: [],
  },
  tags: [],
};

export interface ExpandedProperty {
  replacementKey: string;
  label: string;
  type: string;
  description: string;
  additionalConfiguration: Record<string, any>;
}

export interface ExpandedListProperty {
  replacementKey: string;
  name: string;
  description: string;
  listType: string;
  elementId: number;
  element: ExpandedPropertySet | ExpandedProperty;
}

export interface ExpandedPropertySet {
  replacementKey: string;
  name: string;
  description: string;
  properties: ExpandedProperty[];
  propertySets: ExpandedPropertySet[];
  listProperties: ExpandedListProperty[];
  layout?: any[]; // Legacy field, kept for backward compatibility but no longer used
  additionalConfiguration: {};
}
